import { render, staticRenderFns } from "./FormattedAddress.vue?vue&type=template&id=bebe56c0&scoped=true&"
import script from "./FormattedAddress.vue?vue&type=script&lang=js&"
export * from "./FormattedAddress.vue?vue&type=script&lang=js&"
import style0 from "./FormattedAddress.vue?vue&type=style&index=0&id=bebe56c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebe56c0",
  null
  
)

export default component.exports